<template lang="pug">
  accordion.mailbox(:class='{injected: injected}')
    .pcenter(v-if='status == STATUS.ERROR')
      i.fa.fa-remove.grey.bigIcon
      h2
        small {{$t("globals.error")}}
    .padding(v-if='status == STATUS.LOADING', @fire='doNothing', style="color: white")
      i.fa.fa-refresh.fa-spin
      | &nbsp;&nbsp;
      | {{$t("conversations.loadingOne")}}
    template(v-if='status == STATUS.LOADED')
      conversation(:conversation="conversation", :initial-active='active', :initial-stay-active='stayActive', :injected='injected')


</template>
<script>
import STATUS from '@/utils/status'
import _ from 'lodash'
import api from '@/utils/api'

import Accordion from '@/components/shared/Accordion/Accordion'
import AccordionItem from '@/components/shared/Accordion/Accordion-Item'
import AccordionSubtitle from '@/components/shared/Accordion/Accordion-Subtitle'
import AccordionLoadingHeader from '@/components/shared/Accordion/Accordion-LoadingHeader'

import Conversation from '@/components/Conversations/Conversation'

let newConversation = {
  id: -1,
  kind: 'conversation',
  messages: [],
  lastMessage: '',
  lastMessageTime: 0,
  lastTimeOfView: 0,
  nbMessages: 0,
  onObject: null,
  participants: [],
  senders: [],
  title: 'New conversation',
  unreadMessages: 0
}
export default {
  props: {
    sharedObject: {
      required: true
    },
    injected: {
      default: true
    },
    visible: {
      default: true
    }
  },
  data () {
    return {
      active: true,
      stayActive: true,
      status: STATUS.LOADING,
      conversation: null,
      STATUS
    }
  },
  components: {
    AccordionLoadingHeader,
    AccordionSubtitle,
    AccordionItem,
    Accordion,
    Conversation
  },
  created () {},
  mounted () {
    this.loadConversationIfVisible()
  },
  destroyed () {},
  computed: {},
  methods: {
    loadConversationIfVisible () {
      if (this.visible) {
        this.loadConversation()
      }
    },
    loadConversation () {
      if (this.sharedObject.conversation != null) {
        if (_.isNumber(this.sharedObject.conversation) || _.isString(this.sharedObject.conversation)) {
          api.get('/conversation/' + this.sharedObject.conversation).then((response) => {
            this.conversation = response.data.conversation
            this.status = STATUS.LOADED
          }).catch(() => {
            this.status = STATUS.ERROR
          })
        } else {
          this.conversation = this.sharedObject.conversation
          this.status = STATUS.LOADED
        }
      } else {
        let conv = _.cloneDeep(newConversation)
        this.conversation = conv
        conv.onObject = this.sharedObject
        this.status = STATUS.LOADED
      }
    },
    doNothing () {}
  },
  filters: {},
  watch: {
    visible () {
      this.loadConversationIfVisible()
    },
    sharedObject () {
      this.status = STATUS.LOADING
      this.conversation = null
      this.loadConversationIfVisible()
    }
  }
}
</script>



// WEBPACK FOOTER //
// ConversationOnSharedObject.vue?764dde0d